import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  pieText: {
    fontFamily: ['Poppins', 'Roboto', 'Open Sans', 'sans-serif'].join(','),
    fontWeight: 600,
    color: theme.palette.common.white,
    fontSize: 16,
  },
  root: {
    overflow: 'visible',
  },
}));
